import { SettingConst } from '@faire/web-api--source/types';

/**
 * Relaunch of enabling new bottom sheet modal nudge for app downloads
 * https://www.notion.so/faire/App-nudge-v2-1d72efb5c25a802db9b8dcf6ca3a4615
 */
export const NUX_APP_DOWNLOAD_NUDGES_V2_250724 =
  'NUX_APP_DOWNLOAD_NUDGES_V2_250724' as SettingConst<
    'NUX_APP_DOWNLOAD_NUDGES_V2_250724',
    boolean,
    'RETAILER' | 'HOTJAR_RETAILER' | 'VISITOR_WEB' | 'HOTJAR_VISITOR_WEB'
  >;
